import { Subject } from 'rxjs';
import { addressService } from './service';

const INITIAL_INPUT_ADDRESS = {
  city: '', street: '', dom: '', kv: '', entrance: '', floor: '', korp: '',
  client_comment: '', location: { lat: null, lng: null }, is_dirty: false,
};

export class AddressStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.subject = new Subject();
    this.addresses = null;
    this.inputAddress = Object.assign({}, INITIAL_INPUT_ADDRESS);
    this.district_id = null;
    this.lastSuggestion = null;
    this.userLocation = null;
    // UI state: общий диалог добавления адреса.
    this.addDialogOpen = false;
    this._addDialogCallback = null;
    this.editingAddressId = null; // null = режим создания
  }

  // Открыть диалог в режиме создания. onCreated(address) после сохранения.
  openAddDialog(onCreated) {
    this.resetInputAddress();
    this.resetDistrictId();
    this.setLastSuggestion(null);
    this._addDialogCallback = onCreated || null;
    this.editingAddressId = null;
    this.addDialogOpen = true;
    this._emit();
  }

  // Открыть диалог в режиме редактирования существующего адреса.
  // address — объект из this.addresses. onUpdated(address) после сохранения.
  openEditDialog(address, onUpdated) {
    if (!address || !address.id) return;
    this.resetInputAddress();
    this.setLastSuggestion(null);
    this.setDistrictId(address.district_id);
    this.setInputAddress({
      city: address.city || '',
      street: address.street || '',
      dom: address.dom || '',
      kv: address.kv || '',
      korp: address.korp || '',
      entrance: address.entrance || '',
      floor: address.floor || '',
      client_comment: address.client_comment || '',
      location: {
        lat: (address.location && address.location.lat) || null,
        lng: (address.location && address.location.lng) || null,
      },
    });
    this._addDialogCallback = onUpdated || null;
    this.editingAddressId = address.id;
    this.addDialogOpen = true;
    this._emit();
  }

  closeAddDialog() {
    this.addDialogOpen = false;
    this._addDialogCallback = null;
    this.editingAddressId = null;
    this.resetInputAddress();
    this.resetDistrictId();
    this.setLastSuggestion(null);
    this._emit();
  }
  _fireAddCallback(address) {
    if (this._addDialogCallback) {
      try { this._addDialogCallback(address); } catch (e) { /* noop */ }
    }
  }

  _emit() { this.subject.next(this); }

  get location() {
    const cb = this.rootStore.authStore.mobileToken && this.rootStore.authStore.mobileToken.city_branch;
    if (!cb || !cb.location) return null;
    return { latitude: cb.location.lat, longitude: cb.location.lng };
  }

  get deliveryAvailable() { return !!this.district_id; }

  setAddresses(value) { this.addresses = value || []; this._emit(); }
  setInputAddress(patch) { this.inputAddress = Object.assign({}, this.inputAddress, patch); this._emit(); }
  resetInputAddress() { this.inputAddress = Object.assign({}, INITIAL_INPUT_ADDRESS); this._emit(); }
  setDistrictId(id) { this.district_id = id || null; this._emit(); }
  resetDistrictId() { this.district_id = null; this._emit(); }
  setLastSuggestion(value) { this.lastSuggestion = value || null; this._emit(); }
  setUserLocation(value) { this.userLocation = value || null; this._emit(); }

  async getAddresses() {
    const list = await addressService.getAddresses();
    this.setAddresses(list);
    return list;
  }

  async setAddressByLastSuggest() {
    if (!this.lastSuggestion) return;
    const { lat, lng, address } = this.lastSuggestion;
    this.resetDistrictId();
    this.resetInputAddress();
    this.setInputAddress(Object.assign({}, address, { location: { lat, lng } }));
    this.setLastSuggestion(null);
    const districtId = await addressService.getDistrict(lat, lng);
    if (districtId) this.setDistrictId(districtId);
    return districtId;
  }

  async reverseGeocode(lat, lng) {
    const res = await addressService.reverseGeocode(lat, lng);
    this.resetDistrictId();
    this.resetInputAddress();
    if (res.district_id) {
      const isDirty = !res.address.street || !res.address.dom;
      this.setDistrictId(res.district_id);
      this.setInputAddress(Object.assign({}, res.address, { location: { lat, lng }, is_dirty: isDirty }));
    }
    return res;
  }

  async autocomplete(q, lat, lng) {
    return addressService.autocomplete(q, lat, lng);
  }

  async createAddress(address) {
    const res = await addressService.createAddress(address);
    this.resetDistrictId();
    this.resetInputAddress();
    if (res.address) {
      if (this.addresses) this.setAddresses(this.addresses.concat([res.address]));
      else this.setAddresses([res.address]);
      this._fireAddCallback(res.address);
    }
    return res;
  }

  async updateAddress(id, patch) {
    const res = await addressService.updateAddress(id, patch);
    if (this.addresses && res.address) {
      this.setAddresses(this.addresses.map((a) => (a.id === id ? res.address : a)));
      this._fireAddCallback(res.address);
    }
    return res;
  }

  async deleteAddress(id) {
    // Оптимистично убираем адрес из списка; сервер вернёт актуальный список.
    // При ошибке откатываем и пробрасываем — компонент покажет сообщение.
    const prev = this.addresses;
    if (prev) this.setAddresses(prev.filter((a) => a.id !== id));
    try {
      const list = await addressService.deleteAddress(id);
      this.setAddresses(list);
    } catch (e) {
      if (prev) this.setAddresses(prev);
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/addressStore/index.js